import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'custom-icon-action-cell',
  template: `<button
    class="grid-icon-button"
    (click)="invokeParentMethod()"
    disableRipple="true"
    [disabled]="params.disabled"
    mat-icon-button>
    <i [ngClass]="params.iconClass"></i>
  </button>`,
})

export class CustomIconActionRendererComponent implements ICellRendererAngularComp {
  public params: any;

  agInit(params: any): void {
    this.params = params;
  }

  public invokeParentMethod() {
    if (this.params.actionName) {
      this.params.context.componentParent[this.params.actionName](this.params.node.data);
    } else {
      this.params.context.componentParent.customAction(this.params.node.data);
    }
  }

  refresh(): boolean {
    return false;
  }
}

